/** Safely coerce unknown config value to trimmed string */
export function str(v: unknown): string {
  return typeof v === 'string' ? v.trim() : '';
}

/** Append element to a tracking array and return it (for cleanup) */
export function track<T extends Element>(el: T, arr: Element[]): T {
  arr.push(el);
  return el;
}
